import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationInvalidError extends ExpectedError {
  static override _class = 'RegistrationInvalidError';

  public constructor() {
    super('RegistrationInvalidError', { translationKey: 'REGISTRATION_INVALID_ERROR' });
  }
}
